import React, {useState, useCallback} from 'react';
import { Text, Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';

const color = 'rgb(2, 30, 11)';
export default function GuideLines(props) {
    let sixteen = Array(16).fill(0);
    let width = props.width / 16;
    let height = props.width / 16;
    return (
        <Group>
          {sixteen.map(
              (x, i) =>
                  <Line stroke={color} strokeWidth={1} points={[i * width, 0, i * width, props.height]}
                            />
          )
          }
        {sixteen.map(
            (x, i) =>
                <Line stroke={color} strokeWidth={1} points={[0, i * height, props.width, i * height]}/>)}
        </Group>
    );
}
